import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-openstack',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>OpenStack icon</title><path d="M18.575 9.29h5.418v5.42h-5.418zM0 9.29h5.419v5.42H0zm18.575 7.827a1.207 1.207 0 0 1-1.206 1.206H6.623a1.207 1.207 0 0 1-1.205-1.206v-.858H0v5.252a2.236 2.236 0 0 0 2.229 2.23h19.53A2.237 2.237 0 0 0 24 21.512V16.26h-5.425zM21.763.258H2.233a2.236 2.236 0 0 0-2.23 2.23V7.74h5.419v-.858a1.206 1.206 0 0 1 1.205-1.206h10.746a1.206 1.206 0 0 1 1.205 1.206v.858H24V2.487A2.237 2.237 0 0 0 21.763.258Z"/></svg>`,
    styles: []
})
export class SimpleIconsOpenstackComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#ED1944';
    @Input() className: string = 'simple-icons-openstack'
    constructor() {}
    ngOnInit(): void {}
}
